import axios from 'axios';

const base = () => `${process.env.REACT_APP_API_URL}/election-workflows`;
export const publicWorkflow = (path, data) => data === undefined
  ? axios.get(`${base()}/public/${path}`)
  : axios.post(`${base()}/public/${path}`, data);
export const adminWorkflow = (method, path, data) => axios({
  method, url: `${base()}/${path}`, data,
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});
export const workflowError = error => error.response?.data?.message || 'The request failed. Please try again.';
export const localDateTime = value => {
  if (!value) return '';
  const date = new Date(value);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const displayDate = value => value ? new Date(value).toLocaleString() : '—';
